var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E2FFEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8337 16.0001C12.7541 16.0001 13.5003 15.2539 13.5003 14.3334C13.5003 13.4129 12.7541 12.6667 11.8337 12.6667C10.9132 12.6667 10.167 13.4129 10.167 14.3334C10.167 15.2539 10.9132 16.0001 11.8337 16.0001Z",
    fill: "#41CD70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 16.0001C16.9211 16.0001 17.6673 15.2539 17.6673 14.3334C17.6673 13.4129 16.9211 12.6667 16.0007 12.6667C15.0802 12.6667 14.334 13.4129 14.334 14.3334C14.334 15.2539 15.0802 16.0001 16.0007 16.0001Z",
    fill: "#41CD70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 10.1667H9.33366C8.41449 10.1667 7.66699 10.9151 7.66699 11.8334V16.8334C7.66699 17.7534 8.41449 18.5001 9.33366 18.5001H16.0003V16.8334H9.33366V11.8334H22.667L22.6653 16.0001H24.3337V11.8334C24.3337 10.9151 23.5862 10.1667 22.667 10.1667ZM19.3337 20.6551L17.667 18.9884L16.4887 20.1667L18.7445 22.4234C18.9008 22.5796 19.1127 22.6674 19.3337 22.6674C19.5546 22.6674 19.7666 22.5796 19.9228 22.4234L23.8453 18.5001L22.667 17.3217L19.3337 20.6551Z",
    fill: "#41CD70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCode);
export default __webpack_public_path__ + "static/media/use-code.99412914314ce8123792e1388ef9f151.svg";
export { ForwardRef as ReactComponent };